import Vue from 'vue'
import VueRouter from 'vue-router'
import adminRouter from "@/router/admin";
import expertRouter from "@/router/expert";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: () => {
      return '/login'
    }
  },
  {
    path: '/login',
    component: () =>
      import ('../views/admin/login'),
    meta: {
      title: '社会组织评估填报系统-登录',
      needLogin: false // 是否需要登录才能访问
    }
  },
  {
    path: '/mLogin',
    component: () =>
      import ('../views/mobile/login'),
    meta: {
      title: '社会组织评估填报系统-登录',
      needLogin: false // 是否需要登录才能访问
    }
  },
  {
    path: '/admin',
    component: () =>
      import ('../views/admin/home'),
    children: adminRouter,
  },
  {
    path: '/expert',
    component: () =>
      import ('../views/mobile/expert'),
    children: expertRouter,
  },
]

const router = new VueRouter({
  routes,
  base: process.env.BASE_URL,
  mode: 'history',
  scrollBehavior() {
    return {x: 0, y: 0}
  }
})
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router
